import { render, staticRenderFns } from "./PromotionExtract.vue?vue&type=template&id=1157e7a0"
import script from "./PromotionExtract.vue?vue&type=script&lang=js"
export * from "./PromotionExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports